export const FONT_SIZES = {
  xs: "0.5rem",
  sm: "1rem",
  sm2: "1.125rem",
  sm3: "1.25rem",
  md: "1.5rem",
  lg: "2rem",
  xl: "2.5rem",
};
